import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import VerticalContentCardWithAsset, {
  VerticalContentCardWithAssetProps,
} from 'molecules/VerticalContentCard/VerticalContentCardWithAsset';
import VerticalContentCardWithTextList, {
  VerticalContentCardWithTextListProps,
} from 'molecules/VerticalContentCard/VerticalContentCardWithTextList';
import { VerticalContentCardWrapper } from './VerticalContentCardGrid.styles';

interface VerticalContentCardImageItem {
  type: 'image';
  props: VerticalContentCardWithAssetProps;
}

interface VerticalContentCardTextListItem {
  type: 'text-list';
  props: VerticalContentCardWithTextListProps;
}

export type VerticalContentCardGridItem = VerticalContentCardImageItem | VerticalContentCardTextListItem;

interface VerticalContentCardGridProps {
  items: VerticalContentCardGridItem[];
  totalColumns?: number;
  totalColumnsLg?: number;
  totalColumnsSm?: number;
}

const VerticalContentCardGrid = ({
  items,
  totalColumns = 2,
  totalColumnsLg = 1,
  totalColumnsSm = 1,
}: VerticalContentCardGridProps): JSX.Element => {
  return (
    <Grid
      gap='spacing-3xl'
      totalColumns={totalColumns}
      totalColumnsLg={totalColumnsLg}
      totalColumnsSm={totalColumnsSm}
    >
      {items.map((item, index) => (
        <VerticalContentCardWrapper
          key={index}
          columns={1}
        >
          {item.type === 'image' ? (
            <VerticalContentCardWithAsset
              {...item.props}
              verticalContentCardProps={{
                ...item.props.verticalContentCardProps,
                className: 'vertical-content-card-item',
              }}
            />
          ) : (
            <VerticalContentCardWithTextList
              {...item.props}
              verticalContentCardProps={{
                ...item.props.verticalContentCardProps,
                className: 'vertical-content-card-item',
              }}
            />
          )}
        </VerticalContentCardWrapper>
      ))}
    </Grid>
  );
};

export default VerticalContentCardGrid;
